// @core/api/endpoints/project/update_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SprintResponse,
  UpdateSprintRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update sprint
 * Updates sprint properties like name, dates, or goal. Active sprints have limited modifiable fields to maintain integrity.
 */
export async function UpdateSprint(
  project_id: string,
  sprint_id: string,
  data: UpdateSprintRequest,
  options?: RequestOptions
): Promise<SprintResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.put<SprintResponse>(requestPath, data, requestOptions);
}
